import type {FeatureResource} from '@api/feature/api.d';

/**
 * Returns whether the given account feature flag is present and active.
 * @param accountFeatures Raw account features from the signer store (unknown until loaded).
 * @param featureKey Feature key to look up (see ACCOUNT_FEATURE_KEYS).
 */
export function getIsAccountFeatureActive(accountFeatures: unknown, featureKey: string): boolean {
    if (!Array.isArray(accountFeatures)) {
        return false;
    }

    return !!(accountFeatures as FeatureResource[]).find((feature) => feature?.key === featureKey)?.is_active;
}
